import { SET_DISABLE_CUSTOMER } from '../../types';

const setDisableCustomer = (status) => (dispatch) => {
  dispatch({ type: SET_DISABLE_CUSTOMER, status });
};

export { setDisableCustomer };
